import * as Yup from 'yup';

import i18n from '@/i18n';

const optionalNumberSchema = () =>
  Yup.number()
    .transform((value, originalValue) => {
      if (originalValue === '' || originalValue === null || originalValue === undefined) {
        return null;
      }

      return value;
    })
    .nullable();

export const createOrgSchema = (
  showPaymentDetails: boolean,
  hasChangeOrgSettingsAccess: boolean,
  hasPaymentPlanSelected: boolean,
  hasUnlimitedStoragePermission: boolean,
  hasUnlimitedTributeVideosPermission: boolean
) =>
  Yup.object().shape({
    name: Yup.string()
      .required(i18n.t('nameRequired', { ns: 'common' }))
      .min(2, i18n.t('nameMin', { ns: 'common' }))
      .max(35, i18n.t('nameMax', { ns: 'common' })),
    language: Yup.string().required(i18n.t('languageRequired', { ns: 'common' })),
    eventTypes: Yup.array()
      .min(1, i18n.t('eventTypesRequired', { ns: 'common' }))
      .required(i18n.t('eventTypesRequired', { ns: 'common' })),
    managerName: Yup.string()
      .required(i18n.t('managerNameRequired', { ns: 'common' }))
      .test('min-words', i18n.t('managerNameRequired', { ns: 'common' }), (value) => {
        if (!value) {
          return false;
        }
        const trimmedValue = value.trim();

        const words = trimmedValue.split(/\s+/);

        return words.length >= 2;
      }),
    email: Yup.string()
      .required(i18n.t('emailRequired', { ns: 'common' }))
      .email(i18n.t('emailInvalid', { ns: 'common' })),
    paymentType:
      showPaymentDetails && hasChangeOrgSettingsAccess
        ? Yup.string().required(i18n.t('paymentTypeRequired', { ns: 'common' }))
        : Yup.string().nullable(),
    startDate:
      showPaymentDetails && hasChangeOrgSettingsAccess
        ? Yup.string().required(i18n.t('startDateRequired', { ns: 'common' }))
        : Yup.string().nullable(),
    noOfDays: Yup.number().when('paymentType', {
      is: 'Custom',
      then: (schema) =>
        showPaymentDetails && hasChangeOrgSettingsAccess
          ? schema
              .required(i18n.t('noOfDaysRequired', { ns: 'common' }))
              .min(1, i18n.t('noOfDaysMin', { ns: 'common' }))
          : schema.nullable(),
      otherwise: (schema) => schema.nullable()
    }),
    tributeVideoExportsLimit:
      hasChangeOrgSettingsAccess && hasPaymentPlanSelected && !hasUnlimitedTributeVideosPermission
        ? optionalNumberSchema()
            .required(i18n.t('valueRequired', { ns: 'common' }))
            .min(1, i18n.t('valueMin', { ns: 'common', min: 1 }))
        : optionalNumberSchema().min(1, i18n.t('valueMin', { ns: 'common', min: 1 })),
    storageLimit:
      hasChangeOrgSettingsAccess && hasPaymentPlanSelected && !hasUnlimitedStoragePermission
        ? optionalNumberSchema()
            .required(i18n.t('valueRequired', { ns: 'common' }))
            .min(1, i18n.t('valueMin', { ns: 'common', min: 1 }))
        : optionalNumberSchema().min(1, i18n.t('valueMin', { ns: 'common', min: 1 }))
  });

export const updateOrgSchema = (
  showPaymentDetails: boolean,
  hasChangeOrgSettingsAccess: boolean,
  hasPaymentPlanSelected: boolean,
  hasUnlimitedStoragePermission: boolean,
  hasUnlimitedTributeVideosPermission: boolean
) =>
  Yup.object().shape({
    name: Yup.string()
      .required(i18n.t('nameRequired', { ns: 'common' }))
      .min(2, i18n.t('nameMin', { ns: 'common' }))
      .max(35, i18n.t('nameMax', { ns: 'common' })),
    language: Yup.string().required(i18n.t('languageRequired', { ns: 'common' })),
    eventTypes: Yup.array()
      .min(1, i18n.t('eventTypesRequired', { ns: 'common' }))
      .required(i18n.t('eventTypesRequired', { ns: 'common' })),
    paymentType:
      showPaymentDetails && hasChangeOrgSettingsAccess
        ? Yup.string().required(i18n.t('paymentTypeRequired', { ns: 'common' }))
        : Yup.string().nullable(),
    startDate:
      showPaymentDetails && hasChangeOrgSettingsAccess
        ? Yup.string().required(i18n.t('startDateRequired', { ns: 'common' }))
        : Yup.string().nullable(),
    noOfDays: Yup.number().when('paymentType', {
      is: 'Custom',
      then: (schema) =>
        showPaymentDetails && hasChangeOrgSettingsAccess
          ? schema
              .required(i18n.t('noOfDaysRequired', { ns: 'common' }))
              .min(1, i18n.t('noOfDaysMin', { ns: 'common' }))
          : schema.nullable(),
      otherwise: (schema) => schema.nullable()
    }),
    tributeVideoExportsLimit:
      hasChangeOrgSettingsAccess && hasPaymentPlanSelected && !hasUnlimitedTributeVideosPermission
        ? optionalNumberSchema()
            .required(i18n.t('valueRequired', { ns: 'common' }))
            .min(1, i18n.t('valueMin', { ns: 'common', min: 1 }))
        : optionalNumberSchema().min(1, i18n.t('valueMin', { ns: 'common', min: 1 })),
    storageLimit:
      hasChangeOrgSettingsAccess && hasPaymentPlanSelected && !hasUnlimitedStoragePermission
        ? optionalNumberSchema()
            .required(i18n.t('valueRequired', { ns: 'common' }))
            .min(1, i18n.t('valueMin', { ns: 'common', min: 1 }))
        : optionalNumberSchema().min(1, i18n.t('valueMin', { ns: 'common', min: 1 }))
  });
